"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROFILE_CACHE_KEY = exports.ROLE_CACHE_KEY = exports.TEACHER_ROLE = exports.STUDENT_ROLE = void 0;
exports.STUDENT_ROLE = 'student';
exports.TEACHER_ROLE = 'teacher';
exports.ROLE_CACHE_KEY = 'ROLES';
exports.PROFILE_CACHE_KEY = 'PROFILE';
//# sourceMappingURL=roles.constants.js.map